module.exports = __webpack_public_path__ + "img/homeSec01Top2.5ce566b6.jpg";